@if (!isOnline) {
  <div [@fadeIn] class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-90 text-white backdrop-blur-md">
    <div class="text-center p-8 max-w-md mx-auto bg-gray-800 rounded-xl shadow-2xl border border-gray-700">
      <div [@pulse]="pulseState" class="mb-8 text-red-500 relative inline-block">
        <i class="fas fa-wifi text-8xl"></i>
        <i class="fas fa-ban text-8xl absolute top-0 left-0 text-red-500 opacity-80"></i>
      </div>
      <h1 class="text-3xl font-bold mb-4 text-red-400">¡Sin conexión a Internet!</h1>
      <p class="text-lg mb-8">No pudimos conectarnos a la red. Por favor, verifica tu conexión a Internet e intenta nuevamente.</p>
      <button (click)="tryReconnect()" class="px-6 py-3 bg-red-600 hover:bg-red-700 rounded-lg font-medium transition-all duration-300 transform hover:scale-105 active:scale-95 flex items-center justify-center mx-auto">
        <i class="fas fa-sync-alt mr-2 animate-spin"></i>
        Reintentar conexión
      </button>
    </div>
  </div>
}
